import type { MarketplaceConnectionRequest } from "./api";
import { personRoute } from "./routes";

/**
 * Own-client standing requests (backend `own_client`): the buyer already
 * holds an active link to this pro, so the request is the pro's own buyer
 * locking in their standing offer, not an anonymous marketplace lead. The
 * backend decides the flag, the fee ($0 retention quote) and which name the
 * link shares; these helpers only choose what to render from it.
 */
type OwnClientFields = Pick<
  MarketplaceConnectionRequest,
  "own_client" | "buyer_name" | "contact_id" | "display_code"
>;

export function isOwnClientRequest(r: OwnClientFields): boolean {
  return r.own_client === true;
}

/**
 * The name to show for the buyer: the link-shared name on an own-client row,
 * else the anonymous passport handle. A stray `buyer_name` on a stranger's
 * row is ignored, so anonymity never depends on the backend omitting it.
 */
export function requestBuyerLabel(r: OwnClientFields): string {
  if (isOwnClientRequest(r) && r.buyer_name) return r.buyer_name;
  return r.display_code;
}

/** People deep link for an own-client row, when the contact resolved. */
export function requestPeopleHref(r: OwnClientFields): string | null {
  if (!isOwnClientRequest(r)) return null;
  return personRoute(r.contact_id, "") || null;
}

export const OWN_CLIENT_CONFIRM_LABEL = "Confirm · no fee";
